import React, { Fragment, createRef } from 'react'
import { connect } from 'react-redux'
import Thread from './Thread'
import Input from './Input'

const ThreadAndInput = ({ conversationSelected }) => {
  const inputComponentRef = createRef()

  return (
    <Fragment>
      {conversationSelected && <Thread ref={inputComponentRef} />}
      <Input ref={inputComponentRef} />
    </Fragment>
  )
}

export default connect(
  (state) => ({ conversationSelected: state.inbox.conversationSelected }),
  null,
)(ThreadAndInput)
